import { configureStore } from '@reduxjs/toolkit';
import galleryReducer from './redux/ImageReducer';


const store = configureStore({
   reducer: {
    gallery: galleryReducer,
  },
});

export default store;
